
const TradeCell = ({ first, second, firstAction, secondAction }) => {
    const showValue = (v) => (v === null || v === undefined ? "---" : v);
    const actionClass = (action) => action === "Buy" ? "text-[var(--theme-midlight)]" : "text-[var(--theme2)]";

    return (
        <div className="flex flex-col gap-1">
            <div className={`px-2 py-1 text-sm font-medium rounded-md ${actionClass(firstAction)}`}>
                {showValue(first)}
            </div>
            <div className={`px-2 py-1 text-sm font-medium rounded-md ${actionClass(secondAction)}`}>
                {showValue(second)}
            </div>
        </div>
    );
};

export default TradeCell;